const generateUrlFromBlob = (string = '') => {
  const data = Buffer.from(string, 'base64');

  return window.URL.createObjectURL(new Blob([data]));
};

export default generateUrlFromBlob;
